import API from "@/package/config/axios";
import { LocationQueryValue } from "vue-router";
import {
  IPlaceProductCardResponse,
  IPlaceProductCardsResponse,
} from "@/modules/place-module";

export const apiGetPlaceProducts = (
  placeId: LocationQueryValue | LocationQueryValue[],
  categoryId: number,
  page: number
) => {
  return API.get<IPlaceProductCardsResponse>(
    `api/v2/places/${placeId}/products/${categoryId}`,
    { params: { page: page } }
  );
};

export const apiGetPlaceProductInfo = (
  productId: LocationQueryValue | LocationQueryValue[]
) => {
  return API.get<IPlaceProductCardResponse>(
    `api/v2/places/product/${productId}`
  );
};
